export default [
  {
    path: "/field5ydcjtf", // 无视频
    name: "field5ydcjtf",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field5ydks")
  },
  {
    path: "/field8ydcjtf", // 无视频
    name: "field8ydcjtf",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field8ydks")
  },
  {
    path: "/field9ydcjtf",
    name: "field9ydcjtf",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field9ydks")
  },
  {
    path: "/field12ydcjtf", // 无视频
    name: "field12ydcjtf",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field12ydks")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/cjtf.js